module.exports = __webpack_public_path__ + "img/error.61b07720.svg";